(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeShelf = (container) => {
    if (container.dataset.shelfInitialized === 'true') return;

    const track = container.querySelector('[data-shelf-track]');
    const controls = container.querySelector('[data-shelf-controls]');
    const previousButton = container.querySelector('[data-shelf-previous]');
    const nextButton = container.querySelector('[data-shelf-next]');

    if (!track || !controls || !previousButton || !nextButton) return;

    container.dataset.shelfInitialized = 'true';
    controls.hidden = false;

    const updateControls = () => {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const canScroll = maximumScroll > 2;

      controls.hidden = !canScroll;
      previousButton.disabled = !canScroll || track.scrollLeft <= 2;
      nextButton.disabled = !canScroll || track.scrollLeft >= maximumScroll - 2;
    };

    const moveShelf = (direction) => {
      const firstCard = track.querySelector(':scope > li');
      if (!firstCard) return;

      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      const distance = firstCard.getBoundingClientRect().width + gap;
      track.scrollBy({
        left: distance * direction,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    previousButton.addEventListener('click', () => moveShelf(-1));
    nextButton.addEventListener('click', () => moveShelf(1));
    track.addEventListener('scroll', updateControls, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateControls);
    }

    updateControls();
  };

  const initializeShelves = (root = document) => {
    root.querySelectorAll('[data-clovant-product-shelf]').forEach(initializeShelf);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeShelves());
  } else {
    initializeShelves();
  }

  document.addEventListener('shopify:section:load', (event) => initializeShelves(event.target));
})();
